export const GET_FEEDBACK_FORM = 'GET_FEEDBACK_FORM'
export const RESPONSE_SUBMITTED = 'RESPONSE_SUBMITTED'
